export interface Relationship {
  id: string;
  type: "师兄关系" | "师姐互动" | "同门情谊" | "师徒情" | "暗线纠葛";
  pair: string;
  closeness: "亲密" | "融洽" | "微妙" | "疏离";
  summary: string;
  note: string;
}

export const relationships: Relationship[] = [
  {
    id: "rel-01",
    type: "师兄关系",
    pair: "陆沉渊 × 温如初",
    closeness: "亲密",
    summary: "大师兄与小师弟，一个沉稳一个呆萌，是全峰公认的「长兄如父」组合。",
    note: "陆沉渊嘴上不惯着温如初，背地里却悄悄替他挡了无数次劫难，师兄弟情谊里藏着满满的宠溺。",
  },
  {
    id: "rel-02",
    type: "师姐互动",
    pair: "苏挽月 × 陆沉渊",
    closeness: "微妙",
    summary: "大师姐与大师兄的互动总在针锋相对与默契无间之间反复横跳。",
    note: "一个嫌弃他榆木，一个吐槽她暴躁，可到了生死关头，二人背靠背的默契无需多言，是师姐互动名场面的常客。",
  },
  {
    id: "rel-03",
    type: "同门情谊",
    pair: "云隐峰全员",
    closeness: "亲密",
    summary: "一群嘴上互相嫌弃、心里互为软肋的同门，把「护短」二字刻进了骨子里。",
    note: "师门日常的底色：抢灵果、罚抄、夜谈、救场……吵吵闹闹里全是剪不断的同门情谊。",
  },
  {
    id: "rel-04",
    type: "师徒情",
    pair: "玄真子 × 陆沉渊",
    closeness: "融洽",
    summary: "师尊看似严苛，实则在暗中为徒弟铺了很长一条路。",
    note: "玄真子的严厉与那句「莫让我失望」，背后是深不见底的期许与布局。",
  },
  {
    id: "rel-05",
    type: "暗线纠葛",
    pair: "云渺 × 云隐峰",
    closeness: "疏离",
    summary: "外门师妹云渺的每次出现，都像是平静水面下被掀开的涟漪。",
    note: "她与云隐峰的同门情谊是否另有隐情，身世暗线至今仍是读者反复考据的谜团。",
  },
  {
    id: "rel-06",
    type: "暗线纠葛",
    pair: "顾长风 × 陆沉渊",
    closeness: "微妙",
    summary: "亦敌亦友的对家魔修，与大师兄之间隔着旧怨与新局。",
    note: "每一次重逢都剑拔弩张，却在某几个瞬间流露出不该有的犹豫，是 CP 与暗线讨论的双料热点。",
  },
  {
    id: "rel-07",
    type: "师姐互动",
    pair: "林霜迟 × 苏挽月",
    closeness: "融洽",
    summary: "冷面三师姐与雷厉大师姐，一冷一热，互补得恰到好处。",
    note: "两人平日不多话，却总在任务里打出漂亮的配合，姐妹情谊藏在每一个背对背的瞬间。",
  },
  {
    id: "rel-08",
    type: "师兄关系",
    pair: "沈无咎 × 陆沉渊",
    closeness: "融洽",
    summary: "话痨二师兄与寡言大师兄，一个负责热闹，一个负责兜底。",
    note: "沈无咎的玩笑总被陆沉渊一个眼神压回去，但全峰都知道，论默契没人比得过这对师兄弟。",
  },
];